import { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import Switch from "react-switch";
import cookie from "react-cookies";
import $ from "jquery";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, ecommerceapiUrl, clientheaderconfig } from "../../Helpers/Config";
import { showLoader, hideLoader, showAlert, uploadFile, removeFile } from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Editor from "../Layout/Editor";
import AdminCateringSettings from "./AdminCateringSettings";
var module = "company";
var moduleName = "Settings";
var modulePath = "/clientpanel/outlet";

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageloading: false,
      clientdata: {
        companyName: "",
        companyWebSite: "",
        companyLogo: "",
        companyEnableGuestCheckout: false,
        companyOwnerName: "",
        companyPostalCode: "",
        companyUnitNumber: "",
        companyFloorNumber: "",
        companyAddress: "",
        companyLatitude: "",
        companyLongitude: "",
        companyContactNumber: "",
        companyEmail: "",
        companyOperationalHours: "",
        companyDeliveryOrderingURL: "",
        companyTakeawayOrderingURL: "",
        companyReservationURL: "",
        companyEnableTax: false,
        companyTaxType: "",
        companyEnableTaxPercentage: "",
        companyEnableSubscription: false,
        companyEarnPointPercentage: "",
        companySubscriptionSetting: {
          monthly: { amount: "", infotext: "" },
          quarterly: { amount: "", infotext: "" },
          biannually: { amount: "", infotext: "" },
          annually: { amount: "", infotext: "" },
        },
        companySocialAnalytics: [""],
        companyBonusType: "",
        CreditBonusPercentage: "",
        companyRedeemType: "",
        companyInformation: "",
        companyMenuLink: "",
        companyBillReceiptCompany: "",
        companyBillReceiptCashBack: [
          {
            fromAmount: "",
            toAmount: "",
            cashBackPercentage: "",
            maxAmount: "",
          },
        ],
        companyRatingVoucher1: "",
        companyRatingVoucher2: "",
        companyRatingRotationDays: "",
        companyEnableRatingSendSMS: false,
        companyRatingSendSMSNumber: "",
        companyGSTNumber: "",
        companyTwilioWhatsappOrderNumber: "",
        companyInvoiceLogo: "",
        companyEnableLoyalty: false,
        companyLoyaltyEarnType: "",
        companyLoyaltyEarnPoint: "",
        companyLoyaltyRedeemPoints: "",
        companyLoyaltyRedeemAmount: "",
        companyLoyaltyPointExpiryDays: "",
        companyEnableSpinWheel: false,
        companyRatingSpinWheelPoint: "",
        companyBannerType: "",
        companyThemeColor: "",
        companyNewSignUpPromoCode: "",
        companyAutoApplyPromoCode: "",
        companyCateringOrderNotificationEmail:"",
        companyCateringVenueSurchargeInhouse: "",
        companyCateringVenueSurchargePrivate: "",
        companyCateringVenueSurchargeExternal: "",
        companyCateringDeliveryFeeBase: "",
        companyCateringPayNowDiscountPercent: "",
        companyCateringMinAdvanceDays: "",
        companyCateringBlockedDates: [],
        companyCateringTimeSlots: [],
        companyEnableCatering: false,
      },
      btndisabled: false,
      loading: true,
      tatList: [],
      formpost: [],
      companyDetail: [],
      reviewProductList: [],
      availabiltyList: [],
      promotionList: [],
    };
  }
  componentDidMount = async () => {
    var params = {
      url: apiUrl + module + "/getCompanySettings",
      type: "client",
    };
    this.setState({ pageloading: true });
    this.props.getDetailData(params);
  };
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0]?.message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var companyTaxType = result?.companyTaxType
            ? {
              label: result.companyTaxType,
              value: result.companyTaxType,
            }
            : "";
          var companyBonusType = "";
          if (result?.companyBonusType) {
            var Redeemlabel = "";
            if (result?.companyBonusType === "1") {
              Redeemlabel = "Bonus Model";
            } else if (result?.companyBonusType === "2") {
              Redeemlabel = "Cashback Model";
            } else if (result?.companyBonusType === "3") {
              Redeemlabel = "Scan Receipt Model";
            } else if (result?.companyBonusType === "4") {
              Redeemlabel = "Pin Model";
            } else if (result?.companyBonusType === "5") {
              Redeemlabel = "Check In Model";
            }

            companyBonusType = {
              label: Redeemlabel,
              value: result?.companyBonusType,
            };
          }
          var companyRedeemType = "";
          if (result?.companyRedeemType) {
            var Creditlabel = "";
            if (result?.companyRedeemType === "1") {
              Creditlabel = "Redeem Via Outlet";
            } else if (result?.companyRedeemType === "2") {
              Creditlabel = "Redeem Via  Customer";
            }
            companyRedeemType = {
              label: Creditlabel,
              value: result?.companyRedeemType,
            };
          }
          var companySocialAnalytics = result?.companySocialAnalytics || "";
          const companyBillReceiptCashBack = result?.companyBillReceiptCashBack ?? "";

          const companyLoyaltyEarnType = result?.companyLoyaltyEarnType ?? "";

          let companyBannerType = "";
          if (result.companyBannerType !== "" && result.companyBannerType !== null) {
            if (result.companyBannerType === "sidebyside") {
              companyBannerType = { label: "Side by Side Layout", value: "sidebyside" };
            } else if (result.companyBannerType === "split") {
              companyBannerType = { label: "Single View", value: "split" };
            } else if (result.companyBannerType === "combined") {
              companyBannerType = { label: "Combined Layout (Classic)", value: "combined" };
            }
          }
          
          let companyThemeColor = "";
          if (result.companyThemeColor !== "" && result.companyThemeColor !== null) {
            if (result.companyThemeColor === "classic") {
              companyThemeColor = { label: "Classic Restaurant", value: "classic" };
            } else if (result.companyThemeColor === "mediterranean") {
              companyThemeColor = { label: "Mediterranean / Sumac", value: "mediterranean" };
            } else if (result.companyThemeColor === "modern-cafe") {
              companyThemeColor = { label: "Modern Café", value: "modern-cafe" };
            } else if (result.companyThemeColor === "luxury-dining") {
              companyThemeColor = { label: "Luxury Dining", value: "luxury-dining" };
            } else if (result.companyThemeColor === "street-food") {
              companyThemeColor = { label: "Street Food / Asian Casual", value: "street-food" };
            }
          }

          const companyCateringBlockedDates = result?.companyCateringBlockedDates ?? "";
          const companyCateringTimeSlots = result?.companyCateringTimeSlots ?? "";

          var clientupdatedata = {
            companyName: result.companyName,
            companyWebSite: result.companyWebSite,
            companyLogo: result.companyLogo,
            companyEnableGuestCheckout: result?.companyEnableGuestCheckout || false,
            companyOwnerName: result?.companyOwnerName || "",
            companyPostalCode: result?.companyPostalCode || "",
            companyUnitNumber: result?.companyUnitNumber || "",
            companyFloorNumber: result?.companyFloorNumber || "",
            companyAddress: result?.companyAddress || "",
            companyLatitude: result?.companyLatitude || "",
            companyLongitude: result?.companyLongitude || "",
            companyContactNumber: result?.companyContactNumber || "",
            companyEmail: result?.companyEmail || "",
            companyOperationalHours: result?.companyOperationalHours ?? "",
            companyDeliveryOrderingURL: result?.companyDeliveryOrderingURL ?? "",
            companyTakeawayOrderingURL: result?.companyTakeawayOrderingURL ?? "",
            companyReservationURL: result?.companyReservationURL ?? "",
            companyEnableTax: result?.companyEnableTax || false,
            companyTaxType: companyTaxType,
            companyEnableTaxPercentage: result?.companyEnableTaxPercentage || "",
            companyEnableSubscription: result?.companyEnableSubscription || false,
            companyEarnPointPercentage: result?.companyEarnPointPercentage || "",
            companySubscriptionSetting: result?.companySubscriptionSetting
              ? JSON.parse(result.companySubscriptionSetting)
              : {
                monthly: { amount: "", infotext: "" },
                quarterly: { amount: "", infotext: "" },
                biannually: { amount: "", infotext: "" },
                annually: { amount: "", infotext: "" },
              },

            companySocialAnalytics: companySocialAnalytics !== "" ? companySocialAnalytics.split(",") : [""],
            companyBonusType: companyBonusType,
            companyRedeemType: companyRedeemType,
            CreditBonusPercentage: result?.CreditBonusPercentage,
            companyInformation: result?.companyInformation || "",
            companyMenuLink: result?.companyMenuLink || "",
            companyBillReceiptCompany: result?.companyBillReceiptCompany ?? "",
            companyBillReceiptCashBack:
              companyBillReceiptCashBack !== ""
                ? JSON.parse(companyBillReceiptCashBack)
                : [
                  {
                    fromAmount: "",
                    toAmount: "",
                    cashBackPercentage: "",
                    maxAmount: "",
                  },
                ],
            companyRatingVoucher1: result?.companyRatingVoucher1 || "",
            companyRatingVoucher2: result?.companyRatingVoucher2 || "",
            companyRatingRotationDays: result?.companyRatingRotationDays || "",
            companyEnableRatingSendSMS: result?.companyEnableRatingSendSMS || false,
            companyRatingSendSMSNumber: result?.companyRatingSendSMSNumber || "",
            companyGSTNumber: result?.companyGSTNumber || "",
            companyTwilioWhatsappOrderNumber: result?.companyTwilioWhatsappOrderNumber || "",
            companyInvoiceLogo: result?.companyInvoiceLogo || "",
            companyEnableLoyalty: result?.companyEnableLoyalty ?? false,
            companyLoyaltyEarnType:
              companyLoyaltyEarnType !== ""
                ? {
                  label: companyLoyaltyEarnType,
                  value: companyLoyaltyEarnType,
                }
                : "",
            companyLoyaltyEarnPoint: result?.companyLoyaltyEarnPoint?.$numberDecimal ?? "",

            companyLoyaltyRedeemPoints: result?.companyLoyaltyRedeemPoints?.$numberDecimal || "",
            companyLoyaltyRedeemAmount: result?.companyLoyaltyRedeemAmount?.$numberDecimal || "",
            companyLoyaltyPointExpiryDays: result?.companyLoyaltyPointExpiryDays || "",
            companyEnableSpinWheel: result?.companyEnableSpinWheel ?? false,
            companyRatingSpinWheelPoint: result?.companyRatingSpinWheelPoint?.$numberDecimal || "",
            companyBannerType,
            companyThemeColor,
            companyNewSignUpPromoCode: result?.companyNewSignUpPromoCode || "",
            companyAutoApplyPromoCode: result?.companyAutoApplyPromoCode || "",
            companyEnableCatering: result?.companyEnableCatering || false,
            companyCateringOrderNotificationEmail: result?.companyCateringOrderNotificationEmail || "",
            companyCateringVenueSurchargeInhouse: result?.companyCateringVenueSurchargeInhouse || "",
            companyCateringVenueSurchargePrivate: result?.companyCateringVenueSurchargePrivate || "",
            companyCateringVenueSurchargeExternal: result?.companyCateringVenueSurchargeExternal || "",
            companyCateringDeliveryFeeBase: result?.companyCateringDeliveryFeeBase || "",
            companyCateringPayNowDiscountPercent: result?.companyCateringPayNowDiscountPercent || "",
            companyCateringMinAdvanceDays: result?.companyCateringMinAdvanceDays || "",
            companyCateringBlockedDates: companyCateringBlockedDates !== "" ? JSON.parse(companyCateringBlockedDates) : [],
            companyCateringTimeSlots: companyCateringTimeSlots !== "" ? JSON.parse(companyCateringTimeSlots) : [],
          };
          this.setState({ clientdata: clientupdatedata, pageloading: false }, () => {
            this.loadproductList();

            this.loadPromotion();
          });
        } else {
          this.setState({ pageloading: false });
          this.props.navigate(modulePath);
          showAlert("Error", "Invalid Product", "error");
        }
      });
    }
  }
  loadPromotion() {
    var urlShringTxt = ecommerceapiUrl + "promotion/dropDownList";
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ promotionList: res.data.result }, () => {
            const companyAutoApplyPromoCode = res.data.result.find((item) => item._id === this.state.clientdata.companyAutoApplyPromoCode);
            const companyNewSignUpPromoCode = res.data.result.find((item) => item._id === this.state.clientdata.companyNewSignUpPromoCode);

            if ((companyAutoApplyPromoCode !== "" && companyAutoApplyPromoCode !== null) || (companyNewSignUpPromoCode !== "" && companyNewSignUpPromoCode !== null)) {
              this.setState(
                update(this.state, {
                  clientdata: {
                    companyAutoApplyPromoCode: { $set: companyAutoApplyPromoCode },
                  },
                }),
              );
              setTimeout(() => {
                this.setState(
                  update(this.state, {
                    clientdata: {
                      companyNewSignUpPromoCode: { $set: companyNewSignUpPromoCode },
                    },
                  }),
                );
              }, 1000);
            }
          });
        }
      })
      .catch((e) => { });
  }

  loadproductList() {
    var urlShringTxt = apiUrl + "products/dropdownlist?productType=7";
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ reviewProductList: res.data.result }, () => {
            this.setState({ reviewProductList: res.data.result }, () => {
              const companyRatingVoucher1 = res.data.result.find((item) => item._id === this.state.clientdata.companyRatingVoucher1);
              this.setState(
                update(this.state, {
                  clientdata: {
                    companyRatingVoucher1: { $set: companyRatingVoucher1 },
                  },
                }),
              );
            });
          });
        }
      })
      .catch((error) => {
        this.setState({ reviewProductList: [] });
        console.error("Error fetching data:", error);
      });
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { clientdata: { [field]: { $set: value } } }), () => {
      if (field === "companyPostalCode") {
        if (value.length === 6) {
          this.getAddress(value);
        }
      }
    });
  };

  getAddress(zipcode) {
    const postObject = {
      zipcode: zipcode,
    };
    axios
      .post(apiUrl + "common/zipCode", postObject, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("clientAccessToken")}`,
        },
      })
      .then((res) => {
        if (res.data.status === "ok") {
          var result = res.data.result;
          this.setState(
            update(this.state, {
              clientdata: {
                companyUnitNumber: { $set: result.zip_buno },
                companyAddress: { $set: result.zip_sname },
                companyLatitude: { $set: result.zip_latitude },
                companyLongitude: { $set: result.zip_longitude },
              },
            }),
          );
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;
    const companyLoyaltyEarnPoint = postData.companyLoyaltyEarnPoint ?? "";
    const companyLoyaltyRedeemPoints = postData.companyLoyaltyRedeemPoints ?? "";
    const companyLoyaltyRedeemAmount = postData.companyLoyaltyRedeemAmount ?? "";
    const companyLoyaltyPointExpiryDays = postData.companyLoyaltyPointExpiryDays ?? "";
    const editorContent = $("#editorContent").val();

    let companyRatingVoucher2 = postData.companyRatingVoucher2.length > 0 ? postData.companyRatingVoucher2.map((item) => item.value) : [];

    var postObject = {
      companyName: postData.companyName,
      companyWebSite: postData.companyWebSite,
      companyLogo: postData.companyLogo,
      companyEnableGuestCheckout: postData.companyEnableGuestCheckout ?? false,
      companyOwnerName: postData.companyOwnerName,
      companyPostalCode: postData.companyPostalCode,
      companyUnitNumber: postData.companyUnitNumber,
      companyFloorNumber: postData.companyFloorNumber,
      companyAddress: postData.companyAddress,
      companyLatitude: postData.companyLatitude,
      companyLongitude: postData.companyLongitude,
      companyContactNumber: postData.companyContactNumber,
      companyEmail: postData.companyEmail,
      companyOperationalHours: postData.companyOperationalHours,
      companyDeliveryOrderingURL: postData.companyDeliveryOrderingURL,
      companyTakeawayOrderingURL: postData.companyTakeawayOrderingURL,
      companyReservationURL: postData.companyReservationURL,
      companyEnableTax: postData.companyEnableTax,
      companyTaxType: postData.companyTaxType?.value || "",
      companyEnableTaxPercentage: postData.companyEnableTaxPercentage || "",
      /* companyEarnPointPercentage: postData.companyEarnPointPercentage || "", */
      companySubscriptionSetting: JSON.stringify(postData.companySubscriptionSetting),
      companySocialAnalytics: postData.companySocialAnalytics.length > 0 ? postData.companySocialAnalytics.join(",") : "",
      companyBonusType: postData.companyBonusType?.value || "",
      companyRedeemType: postData.companyRedeemType?.value || "",
      CreditBonusPercentage: postData.CreditBonusPercentage,
      companyInformation: editorContent,
      companyMenuLink: postData.companyMenuLink,
      companyBillReceiptCompany: postData.companyBillReceiptCompany,
      companyBillReceiptCashBack: JSON.stringify(postData.companyBillReceiptCashBack),
      companyRatingVoucher1: postData.companyRatingVoucher1?.value || null,
      companyRatingVoucher2: companyRatingVoucher2.length > 0 ? companyRatingVoucher2.join(",") : "",
      companyRatingRotationDays: postData?.companyRatingRotationDays || '',
      companyEnableRatingSendSMS: postData?.companyEnableRatingSendSMS || false,
      companyRatingSendSMSNumber: postData?.companyRatingSendSMSNumber || "",
      companyGSTNumber: postData.companyGSTNumber,
      companyTwilioWhatsappOrderNumber: postData.companyTwilioWhatsappOrderNumber,
      companyInvoiceLogo: postData.companyInvoiceLogo,
      companyLoyaltyEarnType: postData.companyLoyaltyEarnType?.value ?? "Fixed",
      companyLoyaltyEarnPoint: companyLoyaltyEarnPoint !== "" ? companyLoyaltyEarnPoint : null,
      companyLoyaltyRedeemPoints: companyLoyaltyRedeemPoints !== "" ? companyLoyaltyRedeemPoints : null,
      companyLoyaltyRedeemAmount: companyLoyaltyRedeemAmount !== "" ? companyLoyaltyRedeemAmount : null,
      companyLoyaltyPointExpiryDays: companyLoyaltyPointExpiryDays !== "" ? companyLoyaltyPointExpiryDays : null,
      companyRatingSpinWheelPoint: postData.companyRatingSpinWheelPoint || "",
      companyBannerType: postData.companyBannerType?.value || "",
      companyThemeColor: postData.companyThemeColor?.value || "",
      companyNewSignUpPromoCode: postData?.companyNewSignUpPromoCode?.value || null,
      companyAutoApplyPromoCode: postData?.companyAutoApplyPromoCode?.value || null,
      companyCateringOrderNotificationEmail: postData?.companyCateringOrderNotificationEmail || "",
      companyCateringVenueSurchargeInhouse: postData?.companyCateringVenueSurchargeInhouse || "",
      companyCateringVenueSurchargePrivate: postData?.companyCateringVenueSurchargePrivate || "",
      companyCateringVenueSurchargeExternal: postData?.companyCateringVenueSurchargeExternal || "",
      companyCateringDeliveryFeeBase: postData?.companyCateringDeliveryFeeBase || "",
      companyCateringPayNowDiscountPercent: postData?.companyCateringPayNowDiscountPercent || "",
      companyCateringMinAdvanceDays: postData?.companyCateringMinAdvanceDays || "",
      companyCateringBlockedDates: postData?.companyCateringBlockedDates.length > 0 ? JSON.stringify(postData?.companyCateringBlockedDates) : "",
      companyCateringTimeSlots: postData?.companyCateringTimeSlots.length > 0 ? JSON.stringify(postData?.companyCateringTimeSlots) : "",
      companyEnableSpinWheel: postData?.companyEnableSpinWheel || false,
    };

    var post_url = `${module}/updateSetting`;
    const method = "update";
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage="settings" />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-9 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.clientdata}
                  btndisabled={this.state.btndisabled}
                  reviewProductList={this.state.reviewProductList}
                  availabiltyList={this.state.availabiltyList}
                  promotionList={this.state.promotionList}
                  onChange={this.fieldChange}
                  sateValChange={this.sateValChange}
                  onValid={this.handleSubmit}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 100,
                          },
                          500,
                        );
                      }
                    }, 500);
                  }}
                />
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

const isEmpty = (value) => (value === "" ? "This field is required." : null);
const isValidOption = (taxType, value) => {
  if (Object.keys(taxType).length > 0) {
    return value === "" ? "This field is required." : null;
  }
};
function validationConfig(props) {
  const { companyName, companyTaxType, companyEnableTaxPercentage } = props.fields;

  return {
    fields: ["companyName", "companyTaxType", "companyEnableTaxPercentage"],

    validations: {
      companyName: [[isEmpty, companyName]],
      companyEnableTaxPercentage: [[isValidOption, companyTaxType, companyEnableTaxPercentage]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.setContent = this.setContent.bind(this);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeSwitch(name, checked) {
    this.props.onChange(name, checked);
  }
  setContent(value) {
    this.props.onChange("companyInformation", value);
  }

  async uplaodFiles(imageType) {
    this.props.sateValChange("btndisabled", true);
    showLoader("ImageDetails");
    showLoader("ImageContainer");
    var imagefile = document.querySelector("#" + imageType);
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "company", "client", "epicpay");
    if (fileDetail.status === "ok") {
      this.props.onChange(imageType, fileDetail.url);
    }
    hideLoader("ImageContainer");
    hideLoader("ImageDetails");
    $("#" + imageType).val("");
    this.props.sateValChange("btndisabled", false);
  }
  async removeImage(fileNamme, imageType, e) {
    e.preventDefault();
    showLoader("ImageDetails", "class");
    var fileDetail = await removeFile(fileNamme, "client", "epicpay");
    if (fileDetail.status === "ok") {
      hideLoader("ImageDetails", "class");
      this.props.onChange(imageType, "");
    }
  }

  handleChangeSubscription(types, name, event) {
    var companySubscriptionSetting = this.props.fields.companySubscriptionSetting;
    var nameDetails = types.toLowerCase();
    if (name === "amount") {
      var validNumber = new RegExp(/^\d*\.?\d*$/);
      if (!validNumber.test(event.target.value)) {
        return false;
      }
    }
    companySubscriptionSetting[nameDetails][name] = event.target.value;
    this.props.onChange("companySubscriptionSetting", companySubscriptionSetting);
  }

  handleChangeSocial(addIndex, e) {
    var updsocialanalytics = [];
    if (this.props.fields.companySocialAnalytics.length > 0) {
      this.props.fields.companySocialAnalytics.map((item, index) => {
        if (index === addIndex) {
          updsocialanalytics.push(e.target.value);
        } else {
          updsocialanalytics.push(item);
        }
        return "";
      });
    }
    this.props.onChange("companySocialAnalytics", updsocialanalytics);
  }

  addsocialshare() {
    var companySocialAnalytics = this.props.fields.companySocialAnalytics;
    companySocialAnalytics.push("");
    this.props.onChange("companySocialAnalytics", companySocialAnalytics);
  }
  removesocialshare(removeIndex) {
    var updsocialanalytics = [];
    if (this.props.fields.companySocialAnalytics.length > 0) {
      this.props.fields.companySocialAnalytics.map((item, index) => {
        if (index !== removeIndex) {
          updsocialanalytics.push(item);
        }
        return "";
      });
    }

    this.props.onChange("companySocialAnalytics", updsocialanalytics);
  }

  addBill() {
    let companyBillReceiptCashBack = this.props.fields.companyBillReceiptCashBack;
    companyBillReceiptCashBack.push({
      fromAmount: "",
      toAmount: "",
      cashBackPercentage: "",
      maxAmount: "",
    });
    this.props.onChange("companyBillReceiptCashBack", companyBillReceiptCashBack);
  }
  removeBill(removeIndex) {
    var updBillDetails_ = [];
    if (this.props.fields.companyBillReceiptCashBack.length > 0) {
      this.props.fields.companyBillReceiptCashBack.map((item, index) => {
        if (index !== removeIndex) {
          updBillDetails_.push(item);
        }
        return "";
      });
    }
    this.props.onChange("companyBillReceiptCashBack", updBillDetails_);
  }
  handleBill(addIndex, type, e) {
    var updBillDetails = [];
    if (this.props.fields.companyBillReceiptCashBack.length > 0) {
      this.props.fields.companyBillReceiptCashBack.map((item, index) => {
        if (index === addIndex) {
          const updData = {
            fromAmount: type === "fromAmount" ? e.target.value : item.fromAmount,
            toAmount: type === "toAmount" ? e.target.value : item.toAmount,
            cashBackPercentage: type === "cashBackPercentage" ? e.target.value : item.cashBackPercentage,
            maxAmount: type === "maxAmount" ? e.target.value : item.maxAmount,
          };
          updBillDetails.push(updData);
        } else {
          updBillDetails.push(item);
        }
        return "";
      });
    }
    this.props.onChange("companyBillReceiptCashBack", updBillDetails);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgCompanyName,
      errMsgTax = "";
    if ($validation.companyName.error.reason !== undefined) {
      errMsgCompanyName = $validation.companyName.show && <span className="error">{$validation.companyName.error.reason}</span>;
    }
    if ($validation.companyEnableTaxPercentage.error.reason !== undefined) {
      errMsgTax = $validation.companyEnableTaxPercentage.show && <span className="error">{$validation.companyEnableTaxPercentage.error.reason}</span>;
    }

    var subscriptionTypes = ["Monthly", "Quarterly", "Biannually", "Annually"];
    const companyPlans = cookie.load("companyPlans") ?? "";
    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="row g-3">
          <div className="accordion mt-3 accordion-header-primary" id="accordionStyle1">
            <div className="accordion-item active">
              <h2 className="accordion-header">
                <button type="button" className="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-3" aria-expanded="true">
                  General Info
                </button>
              </h2>
              <div id="accordionStyle1-3" className="accordion-collapse collapse show  mt-3" data-bs-parent="#accordionStyle1">
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={errMsgCompanyName !== "" && errMsgCompanyName !== false && errMsgCompanyName !== undefined ? "form-control is-invalid" : "form-control"}
                          name="companyName"
                          value={fields.companyName}
                          {...$field("companyName", (e) => onChange("companyName", e.target.value))}
                        />
                        <label htmlFor="companyName">
                          Company Name<span className="error">*</span>
                        </label>
                        {errMsgCompanyName}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="companyWebSite"
                          value={fields.companyWebSite}
                          {...$field("companyWebSite", (e) => onChange("companyWebSite", e.target.value))}
                        />
                        <label htmlFor="companyWebSite">Site URL</label>
                      </div>
                    </div>
                    {companyPlans.indexOf("EpicPay") >= 0 && (
                      <>
                        <div className="col-md-6">
                          <div className="form-floating form-floating-outline custm-select-box mb-4 ">
                            <Select
                              value={fields.companyBonusType}
                              onChange={this.handleSelectChange.bind(this, "companyBonusType")}
                              placeholder="Select "
                              options={[
                                { label: "Bonus Model", value: "1" },
                                { label: "Cashback Model", value: "2" },
                                { label: "Scan Receipt Model", value: "3" },
                                { label: "Pin Model", value: "4" },
                                { label: "Check In Model(QR Code)", value: "5" },
                                { label: "Check In Model(In Store)", value: "6" },
                              ]}
                            />
                            <label className="select-box-label">Bonus Credit Type</label>
                          </div>
                        </div>
                        {fields.companyBonusType?.value === "2" && (
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-4">
                              <input
                                type="text"
                                className="form-control"
                                name="CreditBonusPercentage"
                                value={fields.CreditBonusPercentage}
                                {...$field("CreditBonusPercentage", (e) => onChange("CreditBonusPercentage", e.target.value))}
                              />
                              <label htmlFor="CreditBonusPercentage">Credit Percentage</label>
                            </div>
                          </div>
                        )}
                        <div className="col-md-3">
                          <div className="form-floating form-floating-outline custm-select-box mb-4 ">
                            <Select
                              value={fields.companyRedeemType}
                              onChange={this.handleSelectChange.bind(this, "companyRedeemType")}
                              placeholder="Select "
                              options={[
                                { label: "Redeem Via Outlet ", value: "1" },
                                { label: "Redeem Via  Customer", value: "2" },
                              ]}
                            />
                            <label className="select-box-label">Redeem Type</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-floating form-floating-outline mb-4">
                            <input
                              type="text"
                              className="form-control"
                              name="companyMenuLink"
                              value={fields.companyMenuLink}
                              {...$field("companyMenuLink", (e) => onChange("companyMenuLink", e.target.value))}
                            />
                            <label htmlFor="companyMenuLink">Menu URL</label>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="col-md-12">
                      <label>Company Information</label>
                      <Editor IDName={"editorContent"} data={fields.companyInformation !== null ? fields.companyInformation : ""} />
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <div className="mb-3" id="ImageContainer">
                          <label htmlFor="formFile" className="form-label">
                            Company Logo
                          </label>
                          <input
                            className="form-control"
                            type="file"
                            id="companyLogo"
                            onChange={(event) => {
                              this.uplaodFiles("companyLogo", event);
                              return false;
                            }}
                          />
                          For Recommendation Size : <b>200px X 200px</b>
                          <br />
                          For Crop Image :{" "}
                          <b>
                            <a href="https://imageresizer.com/crop-image" target="_blank" rel="noreferrer">
                              click here
                            </a>
                          </b>
                        </div>
                        {fields.companyLogo !== "" && (
                          <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                            <div className="dz-details" id="ImageDetails">
                              <div className="dz-thumbnail">
                                <img alt="" src={fields.companyLogo} />
                              </div>
                            </div>
                            <a className="dz-remove" href="/" onClick={this.removeImage.bind(this, fields.companyLogo, "companyLogo")}>
                              Remove file
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                    {companyPlans.indexOf("EpicPay") >= 0 && (
                      <>
                        <div className="col-md-12"></div>
                        <div className="col-md-3">
                          <div className="form-floating form-floating-outline mb-4">
                            <Switch
                              onChange={this.handleChangeSwitch.bind(this, "companyEnableSpinWheel")}
                              checked={fields.companyEnableSpinWheel}
                              onColor="#666cff"
                              className="react-switch"
                              onHandleColor="#bdbfff"
                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            />
                            <span>Enable SpinWheel</span>
                          </div>
                        </div>
                      </>
                    )}

                    {companyPlans.indexOf("Ecommerce") >= 0 && (
                      <>
                        <div className="col-md-12"></div>
                        <div className="col-md-3">
                          <div className="form-floating form-floating-outline mb-4">
                            <Switch
                              onChange={this.handleChangeSwitch.bind(this, "companyEnableGuestCheckout")}
                              checked={fields.companyEnableGuestCheckout}
                              onColor="#666cff"
                              className="react-switch"
                              onHandleColor="#bdbfff"
                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            />
                            <span>Enable Guest Checkout</span>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-floating form-floating-outline custm-select-box mb-4 ">
                            <Select
                              value={fields.companyBannerType}
                              onChange={this.handleSelectChange.bind(this, "companyBannerType")}
                              placeholder="Select "
                              options={[
                                { label: "Side by Side Layout", value: "sidebyside" },
                                { label: "Single View", value: "split" },
                                { label: "Combined Layout (Classic)", value: "combined" },
                              ]}
                            />
                            <label className="select-box-label">Banner Type</label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-floating form-floating-outline custm-select-box mb-4 ">
                            <Select
                              value={fields.companyThemeColor}
                              onChange={this.handleSelectChange.bind(this, "companyThemeColor")}
                              placeholder="Select "
                              options={[
                                { label: "Classic Restaurant", value: "classic" },
                                { label: "Mediterranean / Sumac", value: "mediterranean" },
                                { label: "Modern Café", value: "modern-cafe" },
                                { label: "Luxury Dining", value: "luxury-dining" },
                                { label: "Street Food / Asian Casual", value: "street-food" },
                              ]}
                            />
                            <label className="select-box-label">Theme</label>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {companyPlans.indexOf("EpicPay") >= 0 && (
              <div className="accordion-item ">
                <h2 className="accordion-header">
                  <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordioncashback" aria-expanded="false">
                    Scan Receipt Cashback Details
                  </button>
                </h2>

                <div id="accordioncashback" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                  <div className="accordion-body">
                    <div className="row g-3">
                      <div className="col-md-12">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="alias_name"
                            value={fields.companyBillReceiptCompany}
                            {...$field("companyBillReceiptCompany", (e) => onChange("companyBillReceiptCompany", e.target.value))}
                          />
                          <label htmlFor="alias_name">Receipt Company Name</label>
                        </div>
                      </div>

                      {fields.companyBillReceiptCashBack.length > 0 &&
                        fields.companyBillReceiptCashBack.map((item, index) => {
                          return (
                            <div className="row g-3" key={index}>
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline mb-4">
                                  <input type="text" className="form-control" name="alias_name" value={item.fromAmount} onChange={this.handleBill.bind(this, index, "fromAmount")} />
                                  <label htmlFor="alias_name">Start Amount</label>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline mb-4">
                                  <input type="text" className="form-control" name="alias_name" value={item.toAmount} onChange={this.handleBill.bind(this, index, "toAmount")} />
                                  <label htmlFor="alias_name">End Amount</label>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline mb-4">
                                  <input type="text" className="form-control" name="alias_name" value={item.cashBackPercentage} onChange={this.handleBill.bind(this, index, "cashBackPercentage")} />
                                  <label htmlFor="alias_name">Cashback Percentage</label>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline mb-4">
                                  <input type="text" className="form-control" name="alias_name" value={item.maxAmount} onChange={this.handleBill.bind(this, index, "maxAmount")} />
                                  <label htmlFor="alias_name">Applicable Maximum Amount</label>
                                </div>
                              </div>

                              <div className="col-md-2">
                                <div className="mt-3">
                                  {fields.companyBillReceiptCashBack.length > 1 && (
                                    <span className="act-minus-icon" onClick={this.removeBill.bind(this, index)}>
                                      <i className="mdi mdi-minus-circle-outline"></i>
                                    </span>
                                  )}
                                  {fields.companyBillReceiptCashBack.length - 1 === index && (
                                    <span className="act-plus-icon" onClick={this.addBill.bind(this)}>
                                      <i className="mdi mdi-plus-circle-outline"></i>
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="accordion-item ">
              <h2 className="accordion-header">
                <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionprice" aria-expanded="false">
                  Contact Info
                </button>
              </h2>

              <div id="accordionprice" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="companyOwnerName"
                          value={fields.companyOwnerName}
                          {...$field("companyOwnerName", (e) => onChange("companyOwnerName", e.target.value))}
                        />
                        <label htmlFor="companyOwnerName">Owner Name</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="companyPostalCode"
                          value={fields.companyPostalCode}
                          {...$field("companyPostalCode", (e) => onChange("companyPostalCode", e.target.value))}
                        />
                        <label htmlFor="companyPostalCode">Postal Code</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="companyUnitNumber"
                          value={fields.companyUnitNumber}
                          {...$field("companyUnitNumber", (e) => onChange("companyUnitNumber", e.target.value))}
                        />
                        <label htmlFor="companyUnitNumber">Unit No.</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="companyFloorNumber"
                          value={fields.companyFloorNumber}
                          {...$field("companyFloorNumber", (e) => onChange("companyFloorNumber", e.target.value))}
                        />
                        <label htmlFor="companyFloorNumber">Floor No.</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="companyAddress"
                          value={fields.companyAddress}
                          {...$field("companyAddress", (e) => onChange("companyAddress", e.target.value))}
                        />
                        <label htmlFor="companyAddress">Address</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="companyContactNumber"
                          value={fields.companyContactNumber}
                          {...$field("companyContactNumber", (e) => onChange("companyContactNumber", e.target.value))}
                        />
                        <label htmlFor="companyContactNumber">Contact Number</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input type="text" className="form-control" name="companyEmail" value={fields.companyEmail} {...$field("companyEmail", (e) => onChange("companyEmail", e.target.value))} />
                        <label htmlFor="companyEmail">Email Address</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {companyPlans.indexOf("EpicPay") >= 0 && (
              <div className="accordion-item ">
                <h2 className="accordion-header">
                  <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionOrderingURL" aria-expanded="false">
                    Ordering URL
                  </button>
                </h2>

                <div id="accordionOrderingURL" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                  <div className="accordion-body">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyOperationalHours"
                            value={fields.companyOperationalHours}
                            {...$field("companyOperationalHours", (e) => onChange("companyOperationalHours", e.target.value))}
                          />
                          <label htmlFor="companyOperationalHours">Operational Hours</label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyDeliveryOrderingURL"
                            value={fields.companyDeliveryOrderingURL}
                            {...$field("companyDeliveryOrderingURL", (e) => onChange("companyDeliveryOrderingURL", e.target.value))}
                          />
                          <label htmlFor="companyDeliveryOrderingURL">Delivery Ordering URL</label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyTakeawayOrderingURL"
                            value={fields.companyTakeawayOrderingURL}
                            {...$field("companyTakeawayOrderingURL", (e) => onChange("companyTakeawayOrderingURL", e.target.value))}
                          />
                          <label htmlFor="companyTakeawayOrderingURL">Takeaway Ordering URL</label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="companyReservationURL"
                            value={fields.companyReservationURL}
                            {...$field("companyReservationURL", (e) => onChange("companyReservationURL", e.target.value))}
                          />
                          <label htmlFor="companyReservationURL">Reservation URL</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="accordion-item ">
              <h2 className="accordion-header">
                <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionvoucher" aria-expanded="false">
                  Tax Settings
                </button>
              </h2>

              <div id="accordionvoucher" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-12">
                      <div className="form-floating form-floating-outline mb-4">
                        <Switch
                          onChange={this.handleChangeSwitch.bind(this, "companyEnableTax")}
                          checked={fields.companyEnableTax}
                          onColor="#666cff"
                          className="react-switch"
                          onHandleColor="#bdbfff"
                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        />
                        <span>Enable Tax</span>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline custm-select-box mb-4 ">
                        <Select
                          value={fields.companyTaxType}
                          onChange={this.handleSelectChange.bind(this, "companyTaxType")}
                          placeholder="Select Tax Type"
                          options={[
                            { label: "Exclusive", value: "Exclusive" },
                            { label: "Inclusive", value: "Inclusive" },
                          ]}
                        />
                        <label className="select-box-label">Tax Type</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={errMsgTax !== "" && errMsgTax !== false && errMsgTax !== undefined ? "form-control is-invalid" : "form-control"}
                          name="companyEnableTaxPercentage"
                          value={fields.companyEnableTaxPercentage}
                          {...$field("companyEnableTaxPercentage", (e) => onChange("companyEnableTaxPercentage", e.target.value))}
                          id="companyEnableTaxPercentage"
                        />
                        <label htmlFor="companyEnableTaxPercentage">Tax Amount Percentage {fields.companyTaxType !== "" && <span className="error">*</span>}</label>
                        {errMsgTax}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {companyPlans.indexOf("Ecommerce") >= 0 && (
              <div className="accordion-item ">
                <h2 className="accordion-header">
                  <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionpromotion" aria-expanded="false">
                    Promotion
                  </button>
                </h2>

                <div id="accordionpromotion" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                  <div className="accordion-body">
                    <div className="row g-3">
                      <div className="col-md-3" style={{ display: "none" }}>
                        <div className="form-floating form-floating-outline custm-select-box mb-4">
                          <Select
                            value={fields.companyNewSignUpPromoCode}
                            onChange={this.handleSelectChange.bind(this, "companyNewSignUpPromoCode")}
                            placeholder="Select New SignUp Promotion"
                            options={this.props.promotionList}
                            isClearable={true}
                          />
                          <label className="select-box-label">New SignUp Promotion</label>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-floating form-floating-outline custm-select-box mb-4">
                          <Select
                            value={fields.companyAutoApplyPromoCode}
                            onChange={this.handleSelectChange.bind(this, "companyAutoApplyPromoCode")}
                            placeholder="Select Auto Apply Promo"
                            options={this.props.promotionList}
                            isClearable={true}
                          />
                          <label className="select-box-label">Auto Apply Promo</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {companyPlans.indexOf("EpicPay") >= 0 && (
              <>
                <div className="accordion-item ">
                  <h2 className="accordion-header">
                    <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionproint" aria-expanded="false">
                      Points EpicPay Settings
                    </button>
                  </h2>

                  <div id="accordionproint" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                    <div className="accordion-body">
                      <div className="row g-3">
                        <div className="col-md-6">
                          <div className="form-floating form-floating-outline mb-4">
                            <input
                              type="text"
                              className="form-control"
                              name="companyEarnPointPercentage"
                              value={fields.companyEarnPointPercentage}
                              {...$field("companyEarnPointPercentage", (e) => onChange("companyEarnPointPercentage", e.target.value))}
                              id="companyEarnPointPercentage"
                              disabled
                            />
                            <label htmlFor="companyEarnPointPercentage">Earn Points Percentage </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {fields.companyEnableSubscription === true && (
                  <div className="accordion-item ">
                    <h2 className="accordion-header">
                      <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionsubscription" aria-expanded="false">
                        Store Subscription
                      </button>
                    </h2>

                    <div id="accordionsubscription" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                      <div className="accordion-body">
                        <div className="row g-3">
                          {subscriptionTypes.map((item, index) => {
                            return (
                              <div className="row g-3" key={index}>
                                <div className="col-md-1">
                                  <h5 className="mb-0">{item}</h5>
                                </div>
                                <div className="col-md-2">
                                  <div className="form-floating form-floating-outline mb-4">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="alias_name"
                                      value={fields.companySubscriptionSetting[item.toLowerCase()].amount}
                                      onChange={this.handleChangeSubscription.bind(this, item, "amount")}
                                    />
                                    <label htmlFor="alias_name">Amount</label>
                                  </div>
                                </div>
                                <div className="col-md-2">
                                  <div className="form-floating form-floating-outline mb-4">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="infotext"
                                      value={fields.companySubscriptionSetting[item.toLowerCase()].infotext}
                                      onChange={this.handleChangeSubscription.bind(this, item, "infotext")}
                                    />
                                    <label htmlFor="alias_name">Save Text</label>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="accordion-item ">
                  <h2 className="accordion-header">
                    <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionsocialanalytics" aria-expanded="false">
                      Generate Unique Links
                    </button>
                  </h2>

                  <div id="accordionsocialanalytics" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                    <div className="accordion-body">
                      <div className="row g-3">
                        {fields.companySocialAnalytics.length > 0 ? (
                          fields.companySocialAnalytics.map((item, index) => {
                            return (
                              <div className="row g-3" key={index}>
                                <div className="col-md-2">
                                  <div className="form-floating form-floating-outline mb-4">
                                    <input type="text" className="form-control" name="alias_name" value={item} onChange={this.handleChangeSocial.bind(this, index)} />
                                    <label htmlFor="alias_name">Name</label>
                                  </div>
                                </div>
                                <div className="col-md-2">
                                  <div className="mt-3">
                                    {fields.companySocialAnalytics.length > 1 && (
                                      <span className="act-minus-icon" onClick={this.removesocialshare.bind(this, index)}>
                                        <i className="mdi mdi-minus-circle-outline"></i>
                                      </span>
                                    )}
                                    {fields.companySocialAnalytics.length - 1 === index && (
                                      <span className="act-plus-icon" onClick={this.addsocialshare.bind(this)}>
                                        <i className="mdi mdi-plus-circle-outline"></i>
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="row g-3">
                            <div className="col-md-2">
                              <div className="form-floating form-floating-outline mb-4">
                                <input
                                  type="text"
                                  className="form-control"
                                /*  onChange={this.handleChangeSubscription.bind(
                              this,
                              item,
                              "amount"
                            )} */
                                />
                                <label htmlFor="alias_name">Name</label>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="mt-3">
                                <span className="act-plus-icon" onClick={this.addsocialshare.bind(this)}>
                                  <i className="mdi mdi-plus-circle-outline"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item ">
                  <h2 className="accordion-header">
                    <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionreview" aria-expanded="false">
                      Review Voucher
                    </button>
                  </h2>

                  <div id="accordionreview" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                    <div className="accordion-body">
                      <div className="row g-3">
                        {/* <div className="col-md-6">
                      <div className="form-floating form-floating-outline custm-select-box mb-4 ">
                        <Select
                          value={fields.companyRatingVoucher1}
                          onChange={this.handleSelectChange.bind(
                            this,
                            "companyRatingVoucher1"
                          )}
                          placeholder="Select Voucher For 1 to 3 Rating"
                          options={this.props.reviewProductList}
                        />
                        <label className="select-box-label">
                          Voucher For 1 to 3 Rating
                        </label>

                      </div>
                    </div> */}
                        <div className="col-md-6">
                          <div className="form-floating form-floating-outline custm-select-box mb-4 ">
                            <Select
                              value={fields.companyRatingVoucher2}
                              onChange={this.handleSelectChange.bind(this, "companyRatingVoucher2")}
                              placeholder="Select Voucher 4 to 5 Rating"
                              options={this.props.reviewProductList}
                              isMulti
                            />
                            <label className="select-box-label">Voucher For 4 to 5 Rating</label>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-floating form-floating-outline mb-4">
                            <input
                              type="text"
                              className="form-control"
                              name="companyRatingRotationDays"
                              value={fields.companyRatingRotationDays}
                              {...$field("companyRatingRotationDays", (e) => onChange("companyRatingRotationDays", e.target.value))}
                            />
                            <label htmlFor="companyRatingRotationDays">Voucher Rotation Days</label>
                          </div>
                        </div>
                        {fields.companyEnableSpinWheel === true && (
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-4">
                              <input
                                type="text"
                                className="form-control"
                                name="companyRatingSpinWheelPoint"
                                value={fields.companyRatingSpinWheelPoint}
                                {...$field("companyRatingSpinWheelPoint", (e) => onChange("companyRatingSpinWheelPoint", e.target.value))}
                              />
                              <label htmlFor="companyRatingSpinWheelPoint">First Time Earn Points</label>
                            </div>
                          </div>
                        )}

                        <div className="col-md-12">
                          <div className="form-floating form-floating-outline mb-4">
                            <Switch
                              onChange={this.handleChangeSwitch.bind(this, "companyEnableRatingSendSMS")}
                              checked={fields.companyEnableRatingSendSMS}
                              onColor="#666cff"
                              className="react-switch"
                              onHandleColor="#bdbfff"
                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                            />
                            <span>Enable Send SMS For 4 & 5 Star</span>
                          </div>
                        </div>

                        {fields.companyEnableRatingSendSMS === true && (
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-4">
                              <input
                                type="text"
                                className="form-control"
                                name="companyRatingSendSMSNumber"
                                value={fields.companyRatingSendSMSNumber}
                                {...$field("companyRatingSendSMSNumber", (e) => onChange("companyRatingSendSMSNumber", e.target.value))}
                                maxLength={8}
                              />
                              <label htmlFor="companyRatingSendSMSNumber">SMS Phone Number</label>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="accordion-item ">
              <h2 className="accordion-header">
                <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionWhatsAppSMSSetting" aria-expanded="false">
                  WhatsApp Message Setting
                </button>
              </h2>

              <div id="accordionWhatsAppSMSSetting" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="companyTwilioWhatsappOrderNumber"
                          value={fields.companyTwilioWhatsappOrderNumber}
                          {...$field("companyTwilioWhatsappOrderNumber", (e) => onChange("companyTwilioWhatsappOrderNumber", e.target.value))}
                        />
                        <label htmlFor="companyTwilioWhatsappOrderNumber">Whats App Order Notification Number</label>
                        <span className="text-danger">Note: Number format +6500000000</span>
                      </div>
                       
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {companyPlans.indexOf("Ecommerce") >= 0 && (
              <>
                <div className="accordion-item ">
                  <h2 className="accordion-header">
                    <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordiongallery" aria-expanded="false">
                      Invoice
                    </button>
                  </h2>

                  <div id="accordiongallery" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                    <div className="accordion-body">
                      <div className="row g-3">
                        <div className="col-md-6">
                          <div className="form-floating form-floating-outline mb-4">
                            <input
                              type="text"
                              className="form-control"
                              name="companyGSTNumber"
                              value={fields.companyGSTNumber}
                              {...$field("companyGSTNumber", (e) => onChange("companyGSTNumber", e.target.value))}
                            />
                            <label htmlFor="companyGSTNumber">GST Reg. No</label>
                          </div>
                        </div>
                        <div className="col-md-6"></div>
                        <div className="col-md-6">
                          <div className="form-floating form-floating-outline mb-4">
                            <div className="mb-3">
                              <label htmlFor="formFile" className="form-label">
                                Invoice Logo
                              </label>
                              <input
                                className="form-control"
                                type="file"
                                id="companyInvoiceLogo"
                                onChange={(event) => {
                                  this.uplaodFiles("companyInvoiceLogo", event);
                                  return false;
                                }}
                              />
                            </div>
                          </div>
                          {fields.companyInvoiceLogo !== "" && (
                            <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                              <div className="dz-details">
                                <div className="dz-thumbnail">
                                  <img alt="" src={fields.companyInvoiceLogo} />
                                </div>
                              </div>
                              <a className="dz-remove" href="/" onClick={this.removeImage.bind(this, fields.companyInvoiceLogo, "companyInvoiceLogo")}>
                                Remove file
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordioncombo-1" aria-expanded="false">
                      Loyalty Settings
                    </button>
                  </h2>

                  <div id="accordioncombo-1" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                    <div className="accordion-body">
                      <div className="row g-3">
                        <div className="col-md-6">
                          <div className="form-floating form-floating-outline custm-select-box mb-4 ">
                            <Select
                              value={fields.companyLoyaltyEarnType}
                              onChange={this.handleSelectChange.bind(this, "companyLoyaltyEarnType")}
                              placeholder="Select Loyalty Earn Type"
                              options={[
                                { label: "Percentage", value: "Percentage" },
                                { label: "Fixed", value: "Fixed" },
                              ]}
                            />
                            <label className="select-box-label">Loyalty Earn Type</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-floating form-floating-outline mb-4">
                            <input
                              type="text"
                              className="form-control"
                              name="companyLoyaltyEarnPoint"
                              value={fields.companyLoyaltyEarnPoint}
                              {...$field("companyLoyaltyEarnPoint", (e) => onChange("companyLoyaltyEarnPoint", e.target.value))}
                            />
                            <label htmlFor="companyLoyaltyEarnPoint">Loyalty Earn Point</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-floating form-floating-outline mb-4">
                            <input
                              type="text"
                              className="form-control"
                              name="companyLoyaltyRedeemPoints"
                              value={fields.companyLoyaltyRedeemPoints}
                              {...$field("companyLoyaltyRedeemPoints", (e) => onChange("companyLoyaltyRedeemPoints", e.target.value))}
                            />
                            <label htmlFor="companyLoyaltyRedeemPoints">Loyalty Redeem Points</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-floating form-floating-outline mb-4">
                            <input
                              type="text"
                              className="form-control"
                              name="companyLoyaltyRedeemAmount"
                              value={fields.companyLoyaltyRedeemAmount}
                              {...$field("companyLoyaltyRedeemAmount", (e) => onChange("companyLoyaltyRedeemAmount", e.target.value))}
                            />
                            <label htmlFor="companyLoyaltyRedeemAmount">Loyalty Redeem Amount</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-floating form-floating-outline mb-4">
                            <input
                              type="text"
                              className="form-control"
                              name="companyLoyaltyPointExpiryDays"
                              value={fields.companyLoyaltyPointExpiryDays}
                              {...$field("companyLoyaltyPointExpiryDays", (e) => onChange("companyLoyaltyPointExpiryDays", e.target.value))}
                            />
                            <label htmlFor="companyLoyaltyPointExpiryDays">Loyalty Expiry Days</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {fields.companyEnableCatering === true && (
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionCateringSettings" aria-expanded="false">
                        Catering Settings
                      </button>
                    </h2>

                    <div id="accordionCateringSettings" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                      <div className="accordion-body">
                        <div className="row g-3">
                          <div className="col-md-12">
                            <AdminCateringSettings settings={fields} handleChangeNumber={this.handleChange.bind(this)} handleChangeText={this.handleChange.bind(this)} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
            <div className="accordion-item ">
              <h2 className="accordion-header">
                <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordionmangeacc" aria-expanded="false">
                  Manage Account
                </button>
              </h2>

              <div id="accordionmangeacc" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-12">
                      <Link to={"/clientpanel/settings"}>
                        <button type="button" className="btn btn-primary me-sm-3 me-1 waves-effect waves-light">
                          Purge All Data
                        </button>
                      </Link>
                      <br />
                      Clears last 3 years data from your account. This action is irreversible.
                    </div>
                    <div className="col-md-12">
                      <Link to={"/clientpanel/settings"}>
                        <button type="button" className="btn btn-danger me-sm-3 me-1 waves-effect waves-light">
                          Delete Account
                        </button>
                      </Link>
                      <br />
                      <div className="text-danger">
                        This will delete your account along with all data.
                        <br />
                        Please ensure all your customers are informed to redeem not limited to cashback, vouchers and points.
                        <br />
                        This action is irreversible.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-1 pb-4 pr-2 text-end" style={{ paddingRight: "20px" }}>
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button type="reset" className="btn btn-label-secondary waves-effect">
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
